import PropTypes from "prop-types";
import { createElement, useEffect } from "react";
import scroller from "./scroller";

interface IElementProps {
  name: string;
}
function withElement(Component: any) {
  function Element(props: IElementProps) {
    const { name } = props;
    const childBindings = {
      domNode: null,
    };

    useEffect(() => {
      registerElems();

      return () => {
        scroller.unregister(name);
      };
    }, [name]);

    function registerElems() {
      scroller.register(name, childBindings.domNode);
    }

    return createElement(Component, { ...props, parentBindings: childBindings });
  }

  Element.propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
  };

  return Element;
}

export default withElement;
